import React from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

import { track, identify } from 'services/tracking';

const VIEW_CERTIFICATE_EVENT = 'Completion Certificate Viewed';

const GET_USER_PROFILE_QUERY = gql`
  query getUserProfile($userId: String!) {
    getUserProfile(userId: $userId) {
      displayname
      employer
      jobTitle
      picture
    }
    getUserHandle(userId: $userId) {
      handle
    }
  }
`;

class UserProfileQuery extends React.Component {
  componentDidMount() {
    const { isLA, certificateId, userId } = this.props;
    const data = {
      url: window.location.href,
      isLA: isLA,
      certificateId: certificateId,
      certificateProfileId: userId
    };
    identify().then(() => track(VIEW_CERTIFICATE_EVENT, data));
  }
  render() {
    return this.props.children(this.props.data);
  }
}

export default graphql(GET_USER_PROFILE_QUERY, {
  options: ({ userId }) => ({ variables: { userId } })
})(UserProfileQuery);

export { GET_USER_PROFILE_QUERY };
